import React from 'react';

const testimonials = [
  {
    name: 'Erin',
    title: 'Prouduct Designer',
    message:
      '"I highly recommend working with Dinesh Kumar and his team. Having collaborated with Minterminds to bring skilled developers on board, I can confidently say they add immense value to every project with their expertise and dedication."',
  },
  {
    name: 'Alan',
    title: 'CEO and Founder',
    message:
      '"I recently had the pleasure of working with Dinesh Kumar, one of the best designers in the industry, to create a custom design for my business. The creativity and meticulous attention to detail he brought to the project were absolutely exceptional, and I couldn’t be happier with the results."',
  },
  {
    name: 'Jaona',
    title: 'Proud Client',
    message:
      '"Thanks to Dinesh Kumar and his team expertise in marketing tools, they consistently provided valuable insights and suggested impactful strategies to optimize our marketing setup. Their approach ensured clarity precision  and effectiveness in every detail."',
  },
];


const Testimonial: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-blue-50 to-white py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between items-start w-full mb-12">
          <div className="flex flex-col max-w-2xl space-y-4">
            <span className="text-xs font-semibold bg-[#e0f8de] text-[#0a6c67] px-4 py-1 rounded-full tracking-wide w-fit">
              TESTIMONIALS
            </span>
            <h1 className="text-3xl md:text-4xl !leading-normal font-bold text-gray-900">
              See what our satisfied customers <br /> have to say about Minterminds
            </h1>
          </div>

          <div className="mt-6 md:mt-0">
            {/* <button className="border-2 border-primary text-primary px-6 py-3 rounded-xl font-bold">
              Write a review
            </button> */}
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-custom hover:shadow-lg transition duration-300"
            >
              <p className="text-[#54595F] text-md">{testimonial.message}</p>

              <div className="flex items-center space-x-4 mt-4">
                <div>
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-[#54595F]">{testimonial.title}</p>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
